import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useRef } from 'react'
import { NumberCountWrapper } from '../NumberCount'
import Parallax from '../Parallax'
import './index.scss'
const TabContent = observer(
  ({
    tab,
    numbers = true,
    isActive,
  }: {
    tab: any
    numbers?: boolean
    isActive: boolean
  }) => {
    const content = useRef<any>(null)

    return (
      <section
        className={classNames('tab-content', isActive && 'active')}
        ref={content}
      >
        <div className="tab-content__img">
          <Parallax
            src={tab?.src ? tab.src : tab.video}
            type={tab?.src ? 'img' : 'video'}
            poster={tab?.src ? '' : tab?.poster}
          />
        </div>
        <div className="tab-content__info">
          <div className="tab-content__text">{tab?.text}</div>
          {numbers && (
            <div className="we-block__list">
              {tab?.numbers?.map((l: any, i: number) => (
                <div className="we-block__item" key={i}>
                  <div className="we-block__item-num">
                    <NumberCountWrapper final={l.num} end={l.end} />
                  </div>
                  <div
                    className="we-block__item-text"
                    dangerouslySetInnerHTML={{ __html: l.text }}
                  ></div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    )
  },
)

export default TabContent
